import { selectFilterForSave } from 'legacy/lut/features/partner360/composedReport'
import { initialSelectsData } from 'legacy/lut/features/partner360/composedReport/configs'
import { getFilterForSave } from 'legacy/lut/features/partner360/composedReport/helpers/getFilterForSave'
import { selectComposedReportState } from 'legacy/lut/features/partner360/composedReport/selectors/selectComposedReportState'
import { createSelector } from 'reselect'

export const selectFilterIsEmpty = createSelector(
  [selectComposedReportState, selectFilterForSave],
  (_, filter) => {
    return JSON.stringify(filter) === JSON.stringify(getFilterForSave(initialSelectsData))
  }
)
